import React from 'react'

import { DateObject } from '../../helpers/date'
import { WalletInput, WalletType } from '../../types/wallet'
import StepOneWalletDetails from './steps/stepOneWalletDetails'
import StepThreePaymentTermAssignment from './steps/stepThreePaymentTermsAssignment'
import StepTwoCreditorsDetails from './steps/stepTwoCreditorsDetails'

interface StepContentProps {
  step: number
  setselectedWalletType: (walletType: WalletType) => void
  walletInput: WalletInput
  setwalletInput: React.Dispatch<React.SetStateAction<WalletInput>>
  selectedWalletType: WalletType | undefined
  coveringRange: DateObject
  setcoveringRange: React.Dispatch<React.SetStateAction<DateObject>>
  sethasFinishedAssigning: React.Dispatch<React.SetStateAction<boolean>>
}

const StepContent: React.FC<StepContentProps> = ({
  step,
  setselectedWalletType,
  setwalletInput,
  walletInput,
  selectedWalletType,
  coveringRange,
  setcoveringRange,
  sethasFinishedAssigning
}) => {
  switch (step) {
    case 0:
      return (
        <StepOneWalletDetails
          {...{
            setselectedWalletType,
            setwalletInput,
            walletInput,
            selectedWalletType
          }}
        />
      )
    case 1:
      return (
        <StepTwoCreditorsDetails
          {...{
            setwalletInput,
            walletInput
          }}
        />
      )
    case 2:
      return (
        <StepThreePaymentTermAssignment
          {...{
            setselectedWalletType,
            setwalletInput,
            walletInput,
            selectedWalletType,
            coveringRange,
            setcoveringRange,
            sethasFinishedAssigning
          }}
        />
      )
    default:
      return <div>Unknown Step</div>
  }
}

export default StepContent
